import AuthInfoMgmt from 'iceqerp-common/auth-info-mgmt';
import apiProxy from './apis/api-proxy-inst';
import authApi from './apis/auth-api';

class MyAuthInfoMgmt extends AuthInfoMgmt {
  constructor() {
    super({ name: 'TM_USER' });
  }

  init() {
    this.load();

    if (!this.isSignedIn()) {
      return Promise.resolve();
    }

    apiProxy.setCertificate(this.getCertificate());

    return authApi
      .renew()
      .then(data => {
        super.signIn(data);
      }).catch(() => {
        this.signOut();
      });
  }

  signInByEmail(args) {
    return authApi
      .loginByEmail(args)
      .then((data) => {
        if (data.succeeded) {
          super.signIn(data);
        }
        return data;
      });
  }

  NextByEmail(args) {
    return authApi
      .forgotByEmail(args)
      .then((data) => {
        if (data.succeeded) {
        }
        return data;
      });
  }

  DataUrlPic(args) {
    return authApi
      .dataPic(args)
      .then((data) => {
        if (data.succeeded) {
          console.log(data);
        }
        return data;
      });
  }

  SuccessDataUrlPic(args) {
    return authApi
      .successDataPic(args)
      .then((data) => {
        if (data.succeeded) {
        }
        return data;
      });
  }

  GetCustomer(args) {
    return authApi
      .getZhuCeCustomer(args)
      .then((data) => {
        if (data.succeeded) {
        }
        return data;
      });
  }

  GetDealer(args) {
    return authApi
      .getZhuCeDealer(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  GetUserEmail(args) {
    return authApi
      .getUserEmail(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  ChangePassWord(args) {
    return authApi
      .changePassword(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  ModifyUserInformation(args) {
    return authApi
      .modifyUserInformation(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  ErpInstList(args) {
    return authApi
      .erpInstList(args)
      .then((data) => {
        return data;
      });
  }

  ErpAppInstList(args) {
    return authApi
      .erpAppInstList(args)
      .then((data) => {
        return data;
      });
  }

  OrderUserList(args) {
    return authApi
      .orderUserList(args)
      .then((data) => {
        if (data.succeeded) {}
        return data;
      });
  }

  signOut() {
    apiProxy.clearCertificate();
    super.signOut();
  }
}

export default new MyAuthInfoMgmt();